import React from 'react';
import reframe from 'nike-re-framejs';

class Redirect extends React.Component {
    UNSAFE_componentWillMount() {
        const { route, params } = this.props;
        reframe.dispatchSync(['navigateSync', route, params]);
    }

    render() {
        return null;
    }
}

export default Redirect;
